import FontSizeChangeEvent from '@adobe-fonts/site/events/FontSizeChangeEvent.js';

import { applyFontSize } from '../../../util/font_card_settings.ts';
import { setTextView } from '../../../util/image_toggle_util.js';
import { updatePrefs } from '../../../util/user_prefs_util.js';

export function registerEventHandlers(element) {
  element.addEventListener(
    FontSizeChangeEvent.EVENT_NAME, event => handleFontSizeChange(event, element));
}

/**
 * Change the text size of the parent element's children elements
 * that have data attribute `data-resizable-sample`
 * Hide images when the font size is changed, and update the user prefs
 *
 * @param {FontSizeChangeEvent} event
 * @param {HTMLElement} parent
 */
export function handleFontSizeChange(event, parent) {
  if (!(event instanceof FontSizeChangeEvent)) {
    return;
  }

  const fontSize = event.detail.fontSize;
  applyFontSize(parent, fontSize);

  setTextView();

  updatePrefs({ exampleText: { size: fontSize }});
};
